"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var commons_1 = require("../../../core/commons");

var ValueWithUnitConverter_1 = require("../../../core/conversions/ValueWithUnitConverter");

var RepriceableItemReleaseProjectionDTO_1 = require("../../model/sellout/RepriceableItemReleaseProjectionDTO");

var RepriceableItemReleaseProjectionDTOConverter_1 = require("./RepriceableItemReleaseProjectionDTOConverter");

var RepriceableItemReleaseProjectionDTOConverterImpl =
/*#__PURE__*/
function (_RepriceableItemRelea) {
  _inherits(RepriceableItemReleaseProjectionDTOConverterImpl, _RepriceableItemRelea);

  function RepriceableItemReleaseProjectionDTOConverterImpl() {
    _classCallCheck(this, RepriceableItemReleaseProjectionDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(RepriceableItemReleaseProjectionDTOConverterImpl).apply(this, arguments));
  }

  _createClass(RepriceableItemReleaseProjectionDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new RepriceableItemReleaseProjectionDTO_1.RepriceableItemReleaseProjectionDTO(RepriceableItemReleaseProjectionDTO_1.RepriceableItemReleaseProjectionDTO.schema.releaseId.valueOf(conversions.toClassReferenceId(source.releaseId)), RepriceableItemReleaseProjectionDTO_1.RepriceableItemReleaseProjectionDTO.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), RepriceableItemReleaseProjectionDTO_1.RepriceableItemReleaseProjectionDTO.schema.siteId.valueOf(conversions.toClassReferenceId(source.siteId)), RepriceableItemReleaseProjectionDTO_1.RepriceableItemReleaseProjectionDTO.schema.endDate.valueOfField(source), RepriceableItemReleaseProjectionDTO_1.RepriceableItemReleaseProjectionDTO.schema.endDateFinalPrice.valueOfField(source), conversions.asObjectOpt(source, 'purchasePrice', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'selloutPrice', function (v) {
        return conversions.toBigNumber(v);
      }), RepriceableItemReleaseProjectionDTO_1.RepriceableItemReleaseProjectionDTO.schema.releaseName.valueOfField(source), RepriceableItemReleaseProjectionDTO_1.RepriceableItemReleaseProjectionDTO.schema.releaseState.valueOfField(source), conversions.asObjectOpt(source, 'estimationInPercent', function (v) {
        return conversions.toBigNumber(v);
      }), RepriceableItemReleaseProjectionDTO_1.RepriceableItemReleaseProjectionDTO.schema.availableSupply.valueOf(conversions.asObjectOpt(source, 'availableSupply', ValueWithUnitConverter_1.ValueWithUnitConverter.deserialize(conversions))), RepriceableItemReleaseProjectionDTO_1.RepriceableItemReleaseProjectionDTO.schema.amount.valueOf(conversions.asObjectOpt(source, 'amount', ValueWithUnitConverter_1.ValueWithUnitConverter.deserialize(conversions))));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return commons_1.UNIMPLEMENTED('RepriceableItemReleaseProjectionDTOConverterImpl.toDocument');
    }
  }]);

  return RepriceableItemReleaseProjectionDTOConverterImpl;
}(RepriceableItemReleaseProjectionDTOConverter_1.RepriceableItemReleaseProjectionDTOConverter);

exports.RepriceableItemReleaseProjectionDTOConverterImpl = RepriceableItemReleaseProjectionDTOConverterImpl;